module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "cabecera-table w-100"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.productsSelected), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "bgWhite wrap"
    }, [_c('td', [_c('rows-table', {
      attrs: {
        "item": item
      }
    })], 1), _vm._v(" "), _c('td', [_c('button-quantity', {
      attrs: {
        "quantity": item.quantity
      },
      on: {
        "on-add": function($event) {
          _vm.add(item)
        },
        "on-sub": function($event) {
          _vm.sub(item)
        }
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getCurrencySymbol) + " " + _vm._s(_vm._f("priceFormat")(item.salePrice || item.priceDiscount)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn-cancel",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteProduct(index)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\tX\n\t\t\t\t\t")])])])
  }))]), _vm._v(" "), _c('p', {
    staticClass: "bar-table flex-70"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-70 d-flex justify-end quantity-article"
  }, [_c('p', {
    staticClass: "total-text"
  }, [_vm._v("Total "), _c('span', [_vm._v("(" + _vm._s(_vm.quantityArticle) + ")")])]), _vm._v(" "), _c('p', {
    staticClass: "total-text"
  }, [_vm._v(_vm._s(_vm.getCurrencySymbol) + " " + _vm._s(_vm._f("round")(_vm.getTotalAmount, 2)))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ARTÍCULO")]), _vm._v(" "), _c('th', [_vm._v("CANTIDAD")]), _vm._v(" "), _c('th', [_vm._v("PRECIO UNITARIO")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6baecf2","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buyTable.vue
// module id = 1164
// module chunks = 36